<script setup lang="ts">
import { useQuery } from '@urql/vue';
import { graphql } from '@/gql';
import { PartnerGroupedServicePreviewList } from '@/features/services';

const props = defineProps<{
  masterId: number;
}>();

const { data: queryData } = await useQuery({
  query: graphql(/* GraphQL */ `
    query MasterServicesTab_MasterQuery($id: Int!) {
      master(id: $id) {
        id
        services {
          id
          ...PartnerGroupedServicePreviewList_PartnerServiceFragment
        }
      }
    }
  `),
  variables: toRef(() => ({
    id: props.masterId,
  })),
});
const services = toRef(() => queryData.value?.master.services);
</script>

<template>
  <PartnerGroupedServicePreviewList
    v-if="services?.length"
    :services="services"
  />
  <div v-else class="stub">У мастера пока нет ни одной услуги</div>
</template>
